import { render, staticRenderFns } from "./Mypage.vue?vue&type=template&id=2720121c&scoped=true&"
import script from "./Mypage.vue?vue&type=script&lang=js&"
export * from "./Mypage.vue?vue&type=script&lang=js&"
import style0 from "./Mypage.vue?vue&type=style&index=0&id=2720121c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2720121c",
  null
  
)

export default component.exports